import { render, staticRenderFns } from "./ImageField.vue?vue&type=template&id=2b5c7349&scoped=true&"
import script from "./ImageField.vue?vue&type=script&lang=js&"
export * from "./ImageField.vue?vue&type=script&lang=js&"
import style0 from "./ImageField.vue?vue&type=style&index=0&id=2b5c7349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c7349",
  null
  
)

export default component.exports